import React from 'react'
import PropTypes from 'prop-types'
import PhotoViewer, { buildViewerPhotos, usePhotoViewer } from '../../ui/PhotoViewer'

const DOWNLOAD_URL_KEY = 'download_url'
const PROXY_URL_KEY = 'proxy_url'
const SPHERICAL_KEY = 'spherical_photo'

const PHOTO_ALT = 'Photo de la réponse'
// Older attachments can carry a blank filename, which would otherwise render an empty link.
const PHOTO_FALLBACK = 'Photo'

const LIST_CLASS = 'tw:flex tw:flex-col tw:gap-2'
const LINK_CLASS = 'tw:inline-flex tw:items-center tw:gap-2 tw:p-0 tw:border-0 tw:bg-transparent '
  + 'tw:text-left tw:text-gray-900 tw:cursor-pointer'

const QuestionPhotos = ({ photos }) => {
  const { handleThumbClick, viewerProps } = usePhotoViewer()

  return (
    <span className={LIST_CLASS}>
      {photos.map((photo, index) => (
        <button
          key={photo.url}
          className={LINK_CLASS}
          data-viewer-index={index}
          type="button"
          onClick={handleThumbClick}
        >
          <i aria-hidden="true" className="far fa-image tw:text-gray-500" />
          <span className="tw:underline! tw:truncate">{photo.filename || PHOTO_FALLBACK}</span>
        </button>
      ))}
      <PhotoViewer photos={buildViewerPhotos(photos, PHOTO_ALT)} {...viewerProps} />
    </span>
  )
}

QuestionPhotos.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.shape({
    [DOWNLOAD_URL_KEY]: PropTypes.string,
    [PROXY_URL_KEY]: PropTypes.string,
    [SPHERICAL_KEY]: PropTypes.bool,
    filename: PropTypes.string,
    url: PropTypes.string.isRequired
  })).isRequired
}

export default QuestionPhotos
